exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".option-option-lCNK6FEjmwr{position:relative}.option-single-IZFJJXYJmwr{padding-left:40px}.option-single-IZFJJXYJmwr::before{visibility:hidden;position:absolute;width:12px;height:12px;margin:4px;left:8px;top:50%;margin-top:-6px}.option-single-IZFJJXYJmwr.option-selected-7ubjHtWjmwr{background-color:var(--ui-subtle-active)}.option-single-IZFJJXYJmwr.option-selected-7ubjHtWjmwr::before{visibility:visible}.option-checkbox-3Z4IR1v3mwr{margin-right:8px}.option-checkbox-3Z4IR1v3mwr,.option-checkbox-3Z4IR1v3mwr label{display:block}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"option": "option-option-lCNK6FEjmwr",
	"single": "option-single-IZFJJXYJmwr option-option-lCNK6FEjmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["icon-before-check"] + "",
	"selected": "option-selected-7ubjHtWjmwr",
	"checkbox": "option-checkbox-3Z4IR1v3mwr"
};